var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSentStaples(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.2 31.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryStaples",
    d: "M14.5,2.7c-.1,0-.2,0-.2.2v.5s.1.2.2.2.2,0,.2-.2v-.5s0-.2-.2-.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryStaples",
    d: "M14,2.2h-.5c-.1,0-.2,0-.2.2s.1.2.2.2h.5c.1,0,.2,0,.2-.2s0-.2-.2-.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryStaples",
    d: "M14.5,1.3c-.1,0-.2.1-.2.2v.5s.1.2.2.2.2,0,.2-.2v-.5c0-.1,0-.2-.2-.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryStaples",
    d: "M15.5,2.2h-.5c-.1,0-.2,0-.2.2s.1.2.2.2h.5c.1,0,.2,0,.2-.2s0-.2-.2-.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryStaples",
    d: "M35.6,26.4c-.2,0-.3.2-.3.3v.8c0,.2,0,.3.3.3s.3-.2.3-.3v-.8s0-.3-.3-.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryStaples",
    d: "M34.8,25.6h-.8c-.2,0-.3.1-.3.3s.2.3.3.3h.8c.2,0,.3-.1.3-.3s0-.3-.3-.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryStaples",
    d: "M35.6,23.9c-.2,0-.3.2-.3.3v.8c0,.2,0,.3.3.3s.3-.2.3-.3v-.8s0-.3-.3-.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryStaples",
    d: "M37.3,25.6h-.8c-.2,0-.3.1-.3.3s.2.3.3.3h.8c.2,0,.3-.1.3-.3s0-.3-.3-.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryStaples",
    d: "M2,18.7s.3,1.9-2,1.9c0,0,2,0,1.9,1.8,0,0,.2-1.4,2-1.8,0,.1-1.5.5-1.9-1.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "emailNeutral4Staples",
    d: "M33.2,5.4s.3,1.9-2,1.9c0,0,2,0,1.9,1.8,0,0,.2-1.4,2-1.8,0,0-1.5.5-1.9-1.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "emailNeutral4Staples",
    d: "M5,30s0,1.1-1.1,1.1c0,0,1,0,1,1,0,0,0-.8,1.1-1,0,0-.8.2-1-1.1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryStaples",
    d: "M6,10.6s0,.6-.6.6c0,0,.6,0,.6.6,0,0,0-.5.6-.6,0,0-.4.2-.6-.6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "emailGreenCheckBkgStaples",
    d: "M16.8,17.1c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9-.3-1.5-.9-2.1-1.3-.9-2.1-.8c-1.5,0-2.8,1.3-2.8,2.9ZM19.6,18.6l-1.2-1.3.4-.4.8.8,1.3-2,.4.3s-1.7,2.6-1.7,2.6Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "emailNeutral4Staples",
    d: "M14,8.6c-.3.3-.5.7-.4,1.1v11.5l1.8,1.5c-.2-.4-.3-.9-.3-1.4v-10.5c0-1,.4-1.9,1-2.6h-1.1c-.3,0-.7,0-1,.4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "emailNeutral4Staples",
    d: "M30.4,29.6c-.1.1-.3.1-.6.1l.4.4c.1-.2.1-.4.2-.5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "emailNeutral4Staples",
    d: "M8.5,18.1h-.2c0-.1,0,11,0,11,0,.3.1.6.2.9l1.6-1.5v-9.1l-1.6-1.3Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "emailNeutral4Staples",
    d: "M28.5,31.2c.4,0,.8-.2,1.1-.4l-1.2-1.2H11.7c-.6,0-1,0-1.3-.1l-1.3,1.3c.3.3.7.4,1.1.4,0,0,18.3,0,18.3,0Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryStaples",
    d: "M24.2,12.1h-1.1c-.7,0-1.2-.7-1.2-1.5v-1.4c0-.1,0-.2-.1-.2,0,0-.1-.1-.2-.1-.2,0-.3.2-.3.4v1.3c0,.6.2,1.2.5,1.6s.8.7,1.3.7h1c.1,0,.3-.2.3-.4s0-.4-.2-.4Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryStaples",
    d: "M31,16.6l-4.4-3.7v1l3.6,3-3.6,3-.6.5v-10.8c0-1.3-1-2.3-2.3-2.3h-8.7c-.6,0-1.2.2-1.7.7s-.7,1-.7,1.6v10.8l-.6-.5-3.6-3,3.6-3v-1l-4.3,3.6c0,.1-.2.2-.2.4v12.3c0,1.5,1.2,2.7,2.7,2.7h18.3c1.5,0,2.7-1.2,2.7-2.7v-12.3c0-.1-.1-.2-.2-.3ZM14,8.6c.3-.3.7-.4,1-.4h8.6c.8,0,1.5.7,1.5,1.5v11.5l-4.5,3.8c-.7.6-1.7.6-2.4,0l-4.6-3.8v-11.5c-.1-.4,0-.8.4-1.1ZM30.4,29.2c0,.3-.1.6-.2.9l-5.5-5.4c-.2-.2-.4-.2-.6,0s-.2.4,0,.6l5.5,5.5c-.3.2-.7.4-1.1.4H10.2c-.4,0-.8-.1-1.1-.4l5.5-5.5c.1-.2.1-.4,0-.5-.2-.1-.4-.1-.6,0l-5.5,5.2c-.1-.3-.2-.6-.2-.9v-11.2l3.9,3.3,5.4,4.5c1,.8,2.5.8,3.5,0l5.4-4.5,3.9-3.3s0,11.3,0,11.3Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSentStaples);
export default __webpack_public_path__ + "static/media/email-sent-staples.9ef4a151ee8d309f7af9dcc43b6d7b61.svg";
export { ForwardRef as ReactComponent };